export default __webpack_public_path__ + "static/media/check-in_flag.4002d5ca.svg";